import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';

import { CalculationParameterMap } from '../../../../types/calculationParameters';
import useRegistrationForm from '../../../../screens/registration/useRegistrationForm';
import { PageWrapper } from '../../../../screens/registrationV2025/pages/solceller';

import { useUpdateParameters } from './useUpdateParameters';
import { State } from './utils';
import { Form } from './form';

interface AdjustParametersProps {
  beregningskjerneInput: CalculationParameterMap;
  parameters: CalculationParameterMap;
  defaultValues: State;
  registrationId: string | undefined;
}

export const AdjustParametersPage: FC<AdjustParametersProps> = ({
  registrationId,
  beregningskjerneInput,
  defaultValues,
  parameters
}) => {
  const { showErrorMessage, nextStep, goToPrevStep, goToStep } = useRegistrationForm();
  const { updateParameters, updateParametersIsLoading } = useUpdateParameters(registrationId);
  const { t } = useTranslation();

  const onSubmit = (data: State) => {
    updateParameters(
      { inputData: beregningskjerneInput, state: data },
      {
        onSuccess: () => {
          if (nextStep) {
            goToStep(nextStep);
          }
        },
        onError: () => showErrorMessage?.()
      }
    );
  };

  const goBack = (state: State) => {
    updateParameters(
      { inputData: beregningskjerneInput, state },
      {
        onSettled: goToPrevStep
      }
    );
  };

  return (
    <PageWrapper>
      <Heading level={1} data-size="lg">
        {t('register.parameters.heading')}
      </Heading>
      <Paragraph>{t('register.parameters.description')}</Paragraph>
      <Form
        parameters={parameters}
        defaultValues={defaultValues}
        isLoading={updateParametersIsLoading}
        onSubmit={onSubmit}
        goBack={goBack}
      />
    </PageWrapper>
  );
};
